import { PageHeader } from '@/components/layout/PageHeader';
import { PatientList } from '@/components/features/patients/PatientList';
import { usePatients } from '@/hooks/usePatients';

export function Patients() {
  const { patients, isLoading, filters, updateFilters } = usePatients();

  return (
    <div>
      <PageHeader
        title="Patients"
        description="Manage and view patient data"
      />

      <PatientList
        patients={patients}
        isLoading={isLoading}
        searchQuery={filters.search || ''}
        onSearchChange={(search) => updateFilters({ search })}
      />
    </div>
  );
}
